<div class="notification">
  <div class="notification__card">
    <svg-icon
      [src]="SVG.time"
      class="notification__icon"
    />
    <span class="notification__title">Your session has expired due to inactivity</span>
    <mdcr-sign-in-form [isModal]="true" />
  </div>
</div>
